import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();


// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


const getSalarios = async () => {
  try {
    const response = await api.get(`${API_URL}salarios`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getListTruckView = async () => {
  try {
    const response = await api.get('truck/listTruckView');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend: ' + error.message);
  }
};

const getOneSalarios = async (id) => {
  try {
    const response = await axios.get(`${API_URL}salarios/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const PostDatosSalarios = async (datos) => {
  try {
    const response = await api.post(`salarios`, datos);
    return response.data;
  } catch (error) {

    if (error.response && error.response.data && error.response.data.message) {
      // Si el error es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      // Si el error no es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const updateSalarios = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}salarios/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ');
  }
};

export { getSalarios, PostDatosSalarios, getOneSalarios, getListTruckView, updateSalarios };